import Footer from '../../components/Footer';
import { Header } from '../../components/Header';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Container, GamesContainer, Row } from './styles';
import { Card } from './components/Card';
import { useEffect, useState } from 'react';
import { apiPHP } from '../../services/api';
import { listDificuldades } from '../../services/admin';

// Item de GET /jogo/torneios: a dificuldade vem só como id.
interface TournamentProps {
  id: number;
  foto: string;
  nome: string;
  edition: string;
  dificuldadesId: number | null;
}

export const Tournaments: React.FC = () => {
  const [tournaments, setTournaments] = useState<TournamentProps[]>([]);
  const [levels, setLevels] = useState<Record<number, string>>({});

  useEffect(() => {
    const getTournaments = async () => {
      const response = await apiPHP.get('/jogo/torneios');

      setTournaments(response.data);
    };

    getTournaments();

    // Sem a lista de níveis, os cards aparecem sem o nome do nível.
    listDificuldades()
      .then((dificuldades) =>
        setLevels(Object.fromEntries(dificuldades.map((d) => [d.id, d.nome])))
      )
      .catch(() => undefined);
  }, []);

  return (
    <Container>
      <Header />
      <GamesContainer>
        <Row>
          <h2>{tournaments.length} Torneios em andamento.</h2>
          <div>
            {tournaments.map((tournament) => (
              <Card
                key={tournament.id}
                id={tournament.id}
                level={
                  tournament.dificuldadesId != null
                    ? levels[tournament.dificuldadesId] ?? ''
                    : ''
                }
                img={tournament.foto}
                name={tournament.nome}
                edition={tournament.edition}
              />
            ))}
          </div>
        </Row>
      </GamesContainer>
      <Footer />
    </Container>
  );
};
